import { Component, Host, h, State, Prop } from '@stencil/core';

@Component({
  tag: 'vs-paddle-buttons',
  styleUrl: '_vs-paddle-buttons.scss',
  shadow: false,
})
export class VsPaddleButtons {
  @Prop() onPaddleClick?: (data: any) => void;
  @State() docDirIsRtl: boolean = false

  componentWillLoad() {
    /* START GENAI@CHATGPT4 */
    this.docDirIsRtl = document.dir === 'rtl'
    /* END GENAI@CHATGPT4 */
  }
  private nextClick = () => {
    this.onPaddleClick("next")
  }
  private prevClick = () => {
    this.onPaddleClick("prev")
  }
  render() {
    return (
      <Host>
        <div class="vs-d-none vs-d-xl-block">
          <button
            aria-label="Previous Slide"
            role="button"
            tabindex="0"
            class="vs-marquee-btn vs-lt-btn"
            onClick={() => (this.docDirIsRtl ? this.nextClick() : this.prevClick())}
          ></button>
          <button
            aria-label="Next Slide"
            role="button"
            tabindex="0"
            class="vs-marquee-btn vs-rt-btn"
            onClick={() => (this.docDirIsRtl ? this.prevClick() : this.nextClick())}
          ></button>
        </div>
      </Host>
    );
  }

}
